/**
 * Article edit UI rules: administrators may edit any post; commadmins only their own.
 * @param {object|null} user – from fetchUser() / users/me (expects id, roles[])
 * @param {number|string|null} authorId – WP post.author
 */
export function canEditArticle(user, authorId) {
  if (!user?.roles || authorId == null || authorId === "") return false;
  const roles = Array.isArray(user.roles) ? user.roles : [];
  if (roles.includes("administrator")) return true;
  if (roles.includes("commadmin") && Number(authorId) === Number(user.id)) return true;
  return false;
}
